module.exports = __webpack_public_path__ + "static/img/ic_ad_adm.d8df616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_ad_adm.png
// module id = TUz9
// module chunks = 0